import { render, staticRenderFns } from "./familiar-ui-nav.vue?vue&type=template&id=895c22aa"
import script from "./familiar-ui-nav.ts?vue&type=script&lang=ts&external"
export * from "./familiar-ui-nav.ts?vue&type=script&lang=ts&external"
import style0 from "./familiar-ui-nav.vue?vue&type=style&index=0&id=895c22aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports